module.exports = __webpack_public_path__ + "static/media/Inspiron5.9661f2a6.png";